import React from 'react';
import { TocGroup } from '../../styles';
import { DocsTocGroup } from '../../types';
import { TocItemRow } from './TocItemRow';

interface TocGroupSectionProps {
  group: DocsTocGroup;
  pathname: string;
  hash: string;
}

export function TocGroupSection({ group, pathname, hash }: TocGroupSectionProps) {
  return (
    <TocGroup>
      {group.items.map((item, itemIndex) => (
        <TocItemRow
          key={`${group.heading}-${item.label}-${itemIndex}`}
          item={item}
          pathname={pathname}
          hash={hash}
        />
      ))}
    </TocGroup>
  );
}
